export var DEPLOY_DATE = new Date('2025-11-07T14:56:58+0000');
